/* contact.js - FUSE contact page. Progressive enhancement: the form works without it. */
(function () {
  'use strict';
  var form = document.getElementById('contact_form');
  if (!form) return;

  /* 1. whitespace-only Name / Message fail validation (no new copy: reuse the browser's own "required" text) */
  var probe = document.createElement('input');
  probe.required = true;
  var nativeMsg = probe.validationMessage;      /* localised, e.g. "Please fill out this field." */
  var guarded = form.querySelectorAll('[data-ct-nonblank]');
  function check(f) { f.setCustomValidity(nativeMsg && f.value.length > 0 && f.value.trim() === '' ? nativeMsg : ''); }
  if (nativeMsg) {
    Array.prototype.forEach.call(guarded, function (f) {
      f.addEventListener('input', function () { check(f); });
      f.addEventListener('change', function () { check(f); });
      check(f);
    });
    window.addEventListener('pageshow', function () { Array.prototype.forEach.call(guarded, check); }); /* restored values fire no input event */
  }

  /* 2. busy state. aria-disabled, never `disabled`: a disabled button drops focus and, with Shopify's hCaptcha layer, hides a stuck send */
  var btn = form.querySelector('button[type="submit"]');
  if (btn) {
    var label = btn.querySelector('span') || btn;
    var idle = label.textContent;
    var busy = btn.getAttribute('data-busy-label') || idle;
    var timer = 0;
    var clear = function () {
      clearTimeout(timer);
      btn.removeAttribute('aria-disabled');
      form.removeAttribute('aria-busy');
      label.textContent = idle;
    };
    form.addEventListener('submit', function (e) {
      if (btn.getAttribute('aria-disabled') === 'true') {   /* second click / Enter while a send is in flight */
        e.preventDefault();
        e.stopImmediatePropagation();                       /* keeps Shopify's listener from starting a second POST */
        return;
      }
      var layer = window.Shopify && window.Shopify.ce_forms;
      if (layer && !form.hasAttribute('data-hcaptcha-bound')) return;   /* not bound yet: Shopify swallows this submit, nothing is sent */
      btn.setAttribute('aria-disabled', 'true');
      form.setAttribute('aria-busy', 'true');
      label.textContent = busy;
      timer = setTimeout(clear, 45000);                     /* hCaptcha rejected / dismissed / network dropped */
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) clear(); });   /* bfcache restores the frozen busy state */
  }

  /* 3. focus the response panel AFTER load (autofocus and DOMContentLoaded lose to the #contact_form fragment navigation: measured) */
  var panel = form.querySelector('[data-ct-focus]');
  if (panel) {
    var anchored = location.hash === '#contact_form';
    if (anchored || /[?&]contact_posted=true(&|$)/.test(location.search)) {   /* a footer-newsletter error (#FooterNewsletter) must not steal focus */
      var go = function () { try { panel.focus({ preventScroll: anchored }); } catch (err) { panel.focus(); } };
      if (document.readyState === 'complete') setTimeout(go, 0); else window.addEventListener('load', function () { setTimeout(go, 0); });
    }
    panel.addEventListener('click', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('a[data-ct-field]') : null;
      var f = a && document.getElementById(a.getAttribute('data-ct-field'));
      if (f) { ev.preventDefault(); f.focus(); }
    });
  }
})();
